<template>
  <v-container v-if="masterId && RBAC_role_GRANT_ROLE">
    <v-row>
      <v-col offset-md="3" md="6" cols="12">
        <base-material-card class="v-card-profile" :avatar="cardUserImage">
          <v-card-text class="text-center">
            <h4 class="display-2 font-weight-light mb-3">{{ fullName }}</h4>
            <v-combobox v-model="publicRole" :items="listRole" item-text="dex" item-value="code"
              :label="$t('public_role')" color="primary"></v-combobox>

            <br />
            <v-text-field v-model="autoPublicRole" :label="$t('auto_public_role')" color="primary"
              disabled></v-text-field>
            <br />

            <v-select multiple chips v-model="authRole" :items="listRole" item-text="dex" item-value="code"
              :label="$t('authorization_roles')" color="primary"></v-select>
            <br />
            <v-select multiple chips disabled v-model="autoRole" :items="autoListRole" item-text="dex" item-value="code"
              :label="$t('auto_authorization_roles')" color="primary"></v-select>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-btn class="mx-5" @click="save" color="success">{{
                  $t("save")
                }}</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "edit-user-role",
  components: {},
  props: {
    masterId: null,
    card: false,
  },
  data() {
    return {
      cardUserImage: "",
      publicRole: "",
      autoPublicRole: "",
      fullName: "",
      autoListRole: [],
      listRole: [],
      authRole: [],
      autoRole: [],
      RBAC_role_GRANT_ROLE: false,
    };
  },
  watch: {
    masterId: function (newVal, oldVal) {
      // watch it
      if (newVal) this.loadData();
    },
  },
  created() {
    let _ = this;
    _.RBAC_role_GRANT_ROLE = _.checkUserRole("role", "GRANT_ROLE");
    _.loadData();
  },
  methods: {
    loadData() {
      let _ = this;
      _.listRole = [];
      _.chiamataAxios("GET", "/auth/portal/listRole").then((response) => {
        _.autoListRole = response.data.filter((role) => {
          return !role.canAssign;
        });
        _.listRole = response.data.filter((role) => {
          return role.canAssign;
        });
        let url = "/auth/portal/getUserData/" + _.masterId;
        _.chiamataAxios("GET", url).then((response) => {
          _.authRole = response.data.user.role;
          _.autoRole = response.data.user.role;
          _.cardUserImage = response.data.user.foto;
          if (
            _.autoListRole
              .map((ruolo) => {
                return ruolo.code;
              })
              .includes(response.data.user.publicRole)
          )
            _.autoPublicRole = _.$t(response.data.user.publicRole);
          else _.publicRole = response.data.user.publicRole;
          _.fullName = response.data.user.fullName;
        });
      });
    },
    save() {
      let _ = this;
      this.chiamataAxios("POST", "/auth/portal/saveUserRole/" + _.masterId, {
        body: { publicRole: _.publicRole, authRole: _.authRole },
      }).then((response) => {
        if (response.msg.esito) {
          let html = "<strong>" + response.msg.msgTxt + "</strong>";
          Swal.fire({
            type: "success",
            html: html,
          });
          _.loadData();
        }
      });
    },
  },
};
</script>
